import React, { Component } from 'react'
import ContainerLogin from '../Containers/ContainerLogin'
import { Link, browserHistory } from 'react-router'
import ReactTable from 'react-table'
import firebase from 'firebase'
import Switch from 'react-ios-switch'
import ObjectEditor from './ObjectEditor'
import CompetencyEditor from './CompetencyEditor'
import NewsEditor from './NewsEditor'
import AdvantagesEditor from './AdvantagesEditor'
import { ToastContainer, toast } from 'react-toastify'
import moment from 'moment'


import 'react-toastify/dist/ReactToastify.min.css'

import 'bulma/css/bulma.css'
import 'react-ios-switch/build/bundle.css'
import 'react-table/react-table.css'
import './styles/ViewAdminStyles.css'

import './styles/ViewAdminStyles.css'

moment.locale()

class ViewAdmin extends Component {

    constructor(props) {
        super(props)

        this.state = {
            editingObject: {}
        }
    }

    componentDidMount() {

        const dbRef = firebase.database().ref('/')

        dbRef.on('value', this.setData.bind(this))
    }

    setData(snapshot) {
        const data = snapshot.val()

        if (data) {

            this.setState({
                ...data
            })
        }
    }

    _checkActive(id) {
        const path = browserHistory.getCurrentLocation().pathname

        const currentPath = path.split('/')[path.split('/').length - 1]
        if (currentPath === '') {
            id = ''
        }

        return currentPath === id
    }
    _renderBackButton() {

        const path = browserHistory.getCurrentLocation().pathname

        const currentPath = path.split('/')[path.split('/').length - 1]

        if (currentPath && currentPath !== '' && currentPath !== 'admin') {
            return (
                <Link className={'BackButton'} onClick={() => {
                    browserHistory.goBack()
                }} />
            )
        } else {
            return null
        }
    }
    _renderDeleteButton() {
        const path = browserHistory.getCurrentLocation().pathname
        const currentPath = path.split('/')[path.split('/').length - 1]
        const hash = browserHistory.getCurrentLocation().hash

        if (hash === '#new') {
            return null
        }

        if (currentPath === 'object') {
            return (
                <Link
                    className={'DeleteButton'}
                    onClick={() => {
                        let object = Object.assign({}, this.refs.ObjectEditor.state)

                        const ref = `objects/${object.id}`
                        firebase.database().ref(ref).remove()
                            .then(() => {
                                toast.success(`Объект успешно удален`, {
                                    position: toast.POSITION.TOP_RIGHT
                                })
                                browserHistory.goBack()
                            })
                            .catch((err) => {
                                toast.success(`Произошла ошибка! Объект не удален`, {
                                    position: toast.POSITION.TOP_RIGHT
                                })
                            })
                    }}
                >
                    {'УДАЛИТЬ'}
                    <div className="DeleteButtonIcon"></div>
                </Link>
            )
        }

        if (currentPath === 'advantagesEditor') {
            return (
                <Link
                    className={'DeleteButton'}
                    onClick={() => {
                        let object = Object.assign({}, this.refs.AdvantagesEditor.state)

                        const ref = `sections/ThirdSection/slides/${object.id}`
                        firebase.database().ref(ref).remove()
                            .then(() => {
                                toast.success(`Объект успешно удален`, {
                                    position: toast.POSITION.TOP_RIGHT
                                })
                                browserHistory.goBack()
                            })
                            .catch((err) => {
                                toast.success(`Произошла ошибка! Объект не удален`, {
                                    position: toast.POSITION.TOP_RIGHT
                                })
                            })
                    }}
                >
                    {'УДАЛИТЬ'}
                    <div className="DeleteButtonIcon"></div>
                </Link>
            )
        }

        if (currentPath === 'competencyEditor') {
            return (
                <Link
                    className={'DeleteButton'}
                    onClick={() => {
                        let object = Object.assign({}, this.refs.CompetencyEditor.state)

                        const ref = `sections/CompetencySection/items/${object.id}`
                        firebase.database().ref(ref).remove()
                            .then(() => {
                                toast.success(`Объект успешно удален`, {
                                    position: toast.POSITION.TOP_RIGHT
                                })
                                browserHistory.goBack()
                            })
                            .catch((err) => {
                                toast.success(`Произошла ошибка! Объект не удален`, {
                                    position: toast.POSITION.TOP_RIGHT
                                })
                            })
                    }}
                >
                    {'УДАЛИТЬ'}
                    <div className="DeleteButtonIcon"></div>
                </Link>
            )
        }

        if (currentPath === 'newsEditor') {
            return (
                <Link
                    className={'DeleteButton'}
                    onClick={() => {
                        let object = Object.assign({}, this.refs.NewsEditor.state)

                        const ref = `sections/NewsSection/news/${object.id}`
                        firebase.database().ref(ref).remove()
                            .then(() => {
                                toast.success(`Объект успешно удален`, {
                                    position: toast.POSITION.TOP_RIGHT
                                })
                                browserHistory.goBack()
                            })
                            .catch((err) => {
                                toast.success(`Произошла ошибка! Объект не удален`, {
                                    position: toast.POSITION.TOP_RIGHT
                                })
                            })
                    }}
                >
                    {'УДАЛИТЬ'}
                    <div className="DeleteButtonIcon"></div>
                </Link>
            )
        }


    }

    _renderCreateSaveButton() {
        const path = browserHistory.getCurrentLocation().pathname
        const currentPath = path.split('/')[path.split('/').length - 1]
        const hash = browserHistory.getCurrentLocation().hash

        if (currentPath === 'settings') {
            return (
                <Link
                    className={'DeleteButton'}
                    onClick={this.props.performLogout}
                >
                    {'ВЫЙТИ'}
                    <div className="DeleteButtonIcon"></div>
                </Link>
            )
        }

        if (currentPath === 'objects') {
            return (
                <Link to={{
                    pathname: `/admin/objects/object`,
                    hash: '#new',
                }} className={'CreateButton'} >
                    {'СОЗДАТЬ'}
                    <div className="CreateButtonIcon"></div>
                </Link>
            )
        } else if (currentPath === 'competency') {
            return (
                <Link to={{
                    pathname: `/admin/competency/competencyEditor`,
                    hash: '#new',
                }} className={'CreateButton'} >
                    {'СОЗДАТЬ'}
                    <div className="CreateButtonIcon"></div>
                </Link>
            )
        } else if (currentPath === 'advantages') {
            return (
                <Link to={{
                    pathname: `/admin/advantages/advantagesEditor`,
                    hash: '#new',
                }} className={'CreateButton'} >
                    {'СОЗДАТЬ'}
                    <div className="CreateButtonIcon"></div>
                </Link>
            )
        } else if (currentPath === 'news') {
            return (
                <Link to={{
                    pathname: `/admin/news/newsEditor`,
                    hash: '#new',
                }} className={'CreateButton'} >
                    {'СОЗДАТЬ'}
                    <div className="CreateButtonIcon"></div>
                </Link>
            )
        } else if (currentPath === 'competencyEditor' && hash && hash.length > 0) {

            return (
                <Link
                    className={'CreateButton'}
                    onClick={() => {
                        const hash = browserHistory.getCurrentLocation().hash

                        let object = Object.assign({}, this.refs.CompetencyEditor.state)

                        if (hash === '#new') {
                            var id = firebase.database().ref('objects/').push().key
                            object.id = id
                            const ref = `sections/CompetencySection/items/${id}`

                            firebase.database().ref(ref).set(object).then(() => {
                                toast.success(`Компетенция успешно создана`, {
                                    position: toast.POSITION.TOP_RIGHT
                                })
                            })
                        } else {
                            const ref = `sections/CompetencySection/items/${object.id}`
                            firebase.database().ref(ref).set(object).then(() => {
                                toast.success(`Данные успешно сохранены`, {
                                    position: toast.POSITION.TOP_RIGHT
                                })
                                browserHistory.replace(`/admin/competency/competencyEditor#${id}`)
                            })
                        }
                    }}
                >
                    {(hash === '#new') ? 'СОЗДАТЬ' : 'СОХРАНИТЬ'}
                    <div className="SaveButtonIcon"></div>
                </Link>
            )
        } else if (currentPath === 'advantagesEditor' && hash && hash.length > 0) {

            return (
                <Link
                    className={'CreateButton'}
                    onClick={() => {
                        const hash = browserHistory.getCurrentLocation().hash
                        let object = Object.assign({}, this.refs.AdvantagesEditor.state)

                        if (hash === '#new') {
                            var id = firebase.database().ref('objects/').push().key
                            object.id = id
                            const ref = `sections/ThirdSection/slides/${id}`

                            firebase.database().ref(ref).set(object).then(() => {
                                toast.success(`Преимущество успешно создано`, {
                                    position: toast.POSITION.TOP_RIGHT
                                })
                                browserHistory.replace(`/admin/advantages/advantagesEditor#${id}`)
                            })
                        } else {
                            const ref = `sections/ThirdSection/slides/${object.id}`
                            firebase.database().ref(ref).set(object).then(() => {
                                toast.success(`Данные успешно сохранены`, {
                                    position: toast.POSITION.TOP_RIGHT
                                })
                            })
                        }
                    }}
                >
                    {(hash === '#new') ? 'СОЗДАТЬ' : 'СОХРАНИТЬ'}
                    <div className="SaveButtonIcon"></div>
                </Link>
            )

        } else if (currentPath === 'object' && hash && hash.length > 0) {

            return (
                <Link
                    className={'CreateButton'}
                    onClick={() => {
                        let object = Object.assign({}, this.refs.ObjectEditor.state)
                        const hash = browserHistory.getCurrentLocation().hash

                        if (hash === '#new') {
                            if (object.title === '') {
                                toast.error(`Вы не ввили название объекта`, {
                                    position: toast.POSITION.TOP_RIGHT
                                })
                            } else {
                                var id = firebase.database().ref('objects/').push().key
                                object.id = id
                                const ref = `objects/${id}`

                                firebase.database().ref(ref).set(object).then(() => {
                                    toast.success(`Объект успешно создан`, {
                                        position: toast.POSITION.TOP_RIGHT
                                    })

                                    this.refs.ObjectEditor.setState({
                                        ...object,
                                        id
                                    })
                                    browserHistory.replace(`/admin/objects/object#${id}`)
                                })
                            }
                        } else {
                            const ref = `objects/${object.id}`
                            firebase.database().ref(ref).set(object).then(() => {
                                toast.success(`Данные успешно сохранены`, {
                                    position: toast.POSITION.TOP_RIGHT
                                })
                            })
                        }
                    }}
                >
                    {(hash === '#new') ? 'СОЗДАТЬ' : 'СОХРАНИТЬ'}
                    <div className="SaveButtonIcon"></div>
                </Link>
            )

        } else if (currentPath === 'newsEditor' && hash && hash.length > 0) {

            return (
                <Link
                    className={'CreateButton'}
                    onClick={() => {
                        let object = Object.assign({}, this.refs.NewsEditor.state)
                        const hash = browserHistory.getCurrentLocation().hash

                        if (hash === '#new') {
                            if (object.title === '') {
                                toast.error(`Вы не ввили заголовок новости`, {
                                    position: toast.POSITION.TOP_RIGHT
                                })
                            } else {
                                var id = firebase.database().ref('sections/NewsSection/news/').push().key
                                object.id = id
                                const ref = `sections/NewsSection/news/${id}`

                                firebase.database().ref(ref).set(object).then(() => {
                                    toast.success(`Новость успешно создана`, {
                                        position: toast.POSITION.TOP_RIGHT
                                    })

                                    this.refs.NewsEditor.setState({
                                        ...object,
                                        id
                                    })

                                    browserHistory.replace(`/admin/news/newsEditor#${id}`)
                                })
                            }
                        } else {
                            const ref = `sections/NewsSection/news/${object.id}`
                            firebase.database().ref(ref).set(object).then(() => {
                                toast.success(`Новость успешно создана`, {
                                    position: toast.POSITION.TOP_RIGHT
                                })
                            })
                        }
                    }}
                >
                    {(hash === '#new') ? 'СОЗДАТЬ' : 'СОХРАНИТЬ'}
                    <div className="SaveButtonIcon"></div>
                </Link>
            )
        } else {
            return null
        }

    }
    _renderModeSwitch() {
        const path = browserHistory.getCurrentLocation().pathname
        const currentPath = path.split('/')[path.split('/').length - 1]

        if (this.state.settings && (currentPath === 'objects')) {
            return (
                <div className="isUpdatingWrapper">
                    <span className="inUpdatingText">
                        {'Редактировать'}
                    </span>
                    <Switch
                        onColor={'#16864e'}
                        checked={this.state.settings.inLineEditingMode}
                        onChange={val => {
                            this._editSettingsField('inLineEditingMode', val)
                        }}
                    />
                </div>
            )
        } else {
            return null
        }
    }
    _renderHeader() {
        const hash = browserHistory.getCurrentLocation().hash
        return (
            <div className="AdminHeader">
                {this._renderBackButton()}
                <div className="AdminHeaderSpacer"></div>
                {(!hash || hash === '') ? this._renderModeSwitch() : null}
                {this._renderCreateSaveButton()}
            </div>
        )
    }
    _getPageTitle() {

        const path = browserHistory.getCurrentLocation().pathname

        const currentPath = path.split('/')[path.split('/').length - 1]

        switch (currentPath) {
            case '':
                return 'Dashboard'
            case 'objects':
                return 'Объекты'
            case 'advantages':
                return 'Преимущества'
            case 'competency':
                return 'Компетенции'
            case 'settings':
                return 'Разделы'
            case 'applications':
                return 'Заявки'
            case 'news':
                return 'Новости'
            default:
                return 'Объекты'
        }
    }
    _renderPageTitle() {
        let title = this._getPageTitle()
        const hash = browserHistory.getCurrentLocation().hash
        if (hash && hash.length > 0) {
            return null
        } else {
            return (
                <div className="column is-12 AdminPageTitle">
                    {title}
                </div>
            )
        }
    }

    _renderAdvantagesEditorPage() {
        if (!this.state.sections || !this.state.sections.ThirdSection) {
            return null
        }

        const hash = browserHistory.getCurrentLocation().hash
        const id = (hash && hash.length > 0) ? hash.split('#')[1] : 'no_id'

        let object = (id === 'new') ? {
            descr: '',
            id: '',
            image: '',
            isVisible: true,
            title: '',

        } : Object.assign({}, this.state.sections.ThirdSection.slides[id])

        return (
            <div>
                <AdvantagesEditor object={object} ref={'AdvantagesEditor'} save={() => {
                    let updatedObject = Object.assign({}, this.refs.AdvantagesEditor.state)
                    const ref = `sections/ThirdSection/slides/${updatedObject.id}`
                    firebase.database().ref(ref).set(updatedObject)
                }} />
                {this.renderFooter()}
            </div>
        )
    }

    _renderNewsEditorPage() {

        const hash = browserHistory.getCurrentLocation().hash
        const id = (hash && hash.length > 0) ? hash.split('#')[1] : 'no_id'



        let object = (id === 'new') ? {
            id: '',
            title: '',
            descr: '',
            date: '',
            isVisible: true,
            photo: '',
            tags: {},
        } : { ...this.state.sections.NewsSection.news[id] }

        return (
            <div>
                <NewsEditor object={object} ref={'NewsEditor'} save={() => {
                    let updatedObject = Object.assign({}, this.refs.NewsEditor.state)
                    const ref = `sections/NewsSection/news/${updatedObject.id}`
                    firebase.database().ref(ref).set(updatedObject)
                }} />
                {this.renderFooter()}
            </div>
        )
    }

    _renderCompetencyEditorPage() {
        if (!this.state.sections || !this.state.sections.CompetencySection) {
            return null
        }
        const hash = browserHistory.getCurrentLocation().hash
        const id = (hash && hash.length > 0) ? hash.split('#')[1] : 'no_id'


        let object = (id === 'new') ? {
            title: '',
            id: '',
            isVisible: true,
            metrics: '',
            descriptor: '',
            tags: {},
            icon: {},
            photo: {},
        } : Object.assign({}, this.state.sections.CompetencySection.items[id])

        return (
            <div>
                <CompetencyEditor object={object} ref={'CompetencyEditor'} save={() => {
                    let updatedObject = Object.assign({}, this.refs.CompetencyEditor.state)
                    const ref = `sections/CompetencySection/items/${updatedObject.id}`
                    firebase.database().ref(ref).set(updatedObject)
                }} />
                {this.renderFooter()}
            </div>

        )
    }

    _renderSettingsPage() {

        if (!this.state.sections) {
            return null
        }

        let data = []

        for (let key in this.state.sections) {
            const section = {
                ...this.state.sections[key],
                route: `sections/${key}/`
            }
            data.push(section)
        }

        const columns = [
            {
                Header: 'Название',
                accessor: 'title',
                Cell: props => {
                    return (
                        <input value={props.value} type="text" onChange={(e) => {
                            const val = e.nativeEvent.target.value
                            const ref = props.original.route
                            firebase.database().ref(ref).update({
                                title: val
                            });
                        }} />
                    )
                }
            },
            {
                Header: 'Описание',
                accessor: 'descr',
                Cell: props => {
                    return (
                        <input value={props.value} type="text" onChange={(e) => {
                            const val = e.nativeEvent.target.value
                            const ref = props.original.route
                            firebase.database().ref(ref).update({
                                descr: val
                            })
                        }} />
                    )
                }
            },
            // {
            //     Header: 'Пункт меню',
            //     accessor: 'isMenuVisible',
            //     Cell: props => {
            //         return (
            //             <div className="TableSwitchWrapper">
            //                 <Switch
            //                     onColor={'#16864e'}
            //                     checked={props.value}
            //                     onChange={val => {
            //                         const ref = props.original.route
            //                         firebase.database().ref(ref).update({
            //                             isMenuVisible: val
            //                         })
            //                     }}
            //                 />
            //             </div>
            //         )
            //     }
            // },
            {
                Header: 'Видимость',
                accessor: 'isVisible',
                Cell: props => {

                    return (
                        <div className="TableSwitchWrapper">
                            <Switch
                                onColor={'#16864e'}
                                checked={props.value}
                                onChange={val => {
                                    const ref = props.original.route
                                    firebase.database().ref(ref).update({
                                        isVisible: val
                                    })
                                }}
                            />
                        </div>
                    )
                }
            }
        ]

        return (
            <div className="ObjectsTable">
                <ReactTable
                    key={'SettingsTagle'}
                    showPagination={false}
                    defaultPageSize={data.length}
                    data={data}
                    columns={columns}
                />
            </div>
        )
    }

    _renderAdvantagesPage() {
        if (!this.state.sections) {
            return null
        }
        let data = []

        for (let key in this.state.sections.ThirdSection.slides) {
            data.push(this.state.sections.ThirdSection.slides[key])
        }

        const columns = [
            {
                Header: 'Название',
                accessor: 'title',
                Cell: props => {
                    return (
                        <Link
                            to={{
                                pathname: `/admin/advantages/advantagesEditor`,
                                hash: `#${props.original.id}`,
                            }}
                        >{props.value}</Link>
                    )
                }
            },
            {
                Header: 'Описание',
                accessor: 'descr',
                Cell: props => {
                    return (
                        <Link
                            to={{
                                pathname: `/admin/advantages/advantagesEditor`,
                                hash: `#${props.original.id}`,
                            }}
                        >{props.value}</Link>
                    )
                }
            },

            {
                Header: 'Видимость',
                accessor: 'isVisible',
                Cell: props => {

                    return (
                        <div className="TableSwitchWrapper">
                            <Switch
                                onColor={'#16864e'}
                                checked={props.value}
                                onChange={val => {
                                    firebase.database().ref(`sections/ThirdSection/slides/${props.original.id}/`).update({
                                        'isVisible': val
                                    })

                                }}
                            />
                        </div>
                    )
                }
            }
        ]

        return (
            <div className="ObjectsTable">
                <ReactTable
                    key={'AdvantagesTagle'}
                    showPagination={false}
                    defaultPageSize={data.length}
                    data={data}
                    columns={columns}
                />
            </div>
        )
    }

    _renderCompetencyPage() {
        if (!this.state.sections) {
            return null
        }
        let data = []

        for (let key in this.state.sections.CompetencySection.items) {
            data.push(this.state.sections.CompetencySection.items[key])
        }

        const columns = [
            {
                Header: 'Название',
                accessor: 'title',
                Cell: props => {
                    return (
                        <Link
                            to={{
                                pathname: `/admin/competency/competencyEditor`,
                                hash: `#${props.original.id}`,
                            }}
                        >{props.value}</Link>
                    )
                }
            },
            {
                Header: 'Сдано, м',
                accessor: 'metrics',
                Cell: props => {
                    return (
                        <Link
                            to={{
                                pathname: `/admin/competency/competencyEditor`,
                                hash: `#${props.original.id}`,
                            }}
                        >{props.value}</Link>
                    )
                }
            },
            {
                Header: 'Теги',
                accessor: 'tags',
                Cell: props => {

                    let tagsStr = []

                    for (let key in props.original.tags) {
                        tagsStr.push(`-${props.original.tags[key].title}`)
                    }
                    return (
                        <Link
                            to={{
                                pathname: `/admin/competency/competencyEditor`,
                                hash: `#${props.original.id}`,
                            }}
                        >{tagsStr.join(' ')}</Link>
                    )

                }
            },
            {
                Header: 'Видимость',
                accessor: 'isVisible',
                Cell: props => {

                    return (
                        <div className="TableSwitchWrapper">
                            <Switch
                                onColor={'#16864e'}
                                checked={props.value}
                                onChange={val => {

                                    firebase.database().ref(`sections/CompetencySection/items/${props.original.id}/`).update({
                                        'isVisible': val
                                    })
                                }}
                            />
                        </div>
                    )
                }
            }
        ]

        return (
            <div className="ObjectsTable">
                <ReactTable
                    key={'CompetencyTagle'}
                    showPagination={false}
                    defaultPageSize={data.length}
                    data={data}
                    columns={columns}
                />
            </div>
        )
    }

    _renderObjectPage() {
        const hash = browserHistory.getCurrentLocation().hash
        const id = (hash && hash.length > 0) ? hash.split('#')[1] : 'no_id'

        let object = (id === 'new') ? {
            address: '',
            builder: '',
            date: '',
            descr: '',
            id: '',
            isReady: false,
            isVisible: false,
            photo: '',
            tags: {},
            title: ''
        } : Object.assign({}, this.state.objects[id])

        // if (!this.state.objects) {
        //     return null
        // }

        return (
            <div className={'EditorsWrapper'}>
                <ObjectEditor
                    object={object}
                    ref={'ObjectEditor'}
                    save={() => {
                        let objId = (object.id === '') ? null : object.id
                        if (!objId) {
                            objId = firebase.database().ref('objects/').push().key
                            object.id = objId
                            let updatedObject = Object.assign({}, this.refs.ObjectEditor.state)
                            updatedObject.id = objId
                            const ref = `objects/${object.id}`
                            firebase.database().ref(ref).set(updatedObject)
                        } else {
                            let updatedObject = Object.assign({}, this.refs.ObjectEditor.state)
                            const ref = `objects/${object.id}`
                            firebase.database().ref(ref).set(updatedObject)
                        }

                    }}
                />
                {this.renderFooter()}
            </div>
        )
    }

    renderFooter() {
        return (
            <div className="AdminFooter">
                {this._renderBackButton()}
                <div className="AdminHeaderSpacer"></div>
                {this._renderDeleteButton()}
            </div>
        )
    }

    getContent() {
        const path = browserHistory.getCurrentLocation().pathname

        const currentPath = path.split('/')[path.split('/').length - 1]

        switch (currentPath) {
            case '':
                return 'root'
            case 'objects':
                return this._renderPageObjects()
            case 'object':
                return this._renderObjectPage()
            case 'advantages':
                return this._renderAdvantagesPage()
            case 'advantagesEditor':
                return this._renderAdvantagesEditorPage()
            case 'competency':
                return this._renderCompetencyPage()
            case 'competencyEditor':
                return this._renderCompetencyEditorPage()
            case 'settings':
                return this._renderSettingsPage()
            case 'applications':
                return this._renderPageApplications()
            case 'news':
                return this._renderNewsPage()
            case 'newsEditor':
                return this._renderNewsEditorPage()
            default:
                return this._renderPageObjects()
            // return 'default'

        }
    }

    _editObjectField(id, field, val) {
        const ref = `objects/${id}/`

        firebase.database().ref(ref).update({
            [field]: val
        });

    }

    _editSettingsField(field, val) {
        const ref = `settings/`

        firebase.database().ref(ref).update({
            [field]: val
        });

    }

    _renderObjectsTableCall(props) {
        const id = props.original.id
        const field = props.column.id

        if (this.state.settings.inLineEditingMode) {
            return (
                <input value={props.value} type="text" onChange={(e) => {
                    const val = e.nativeEvent.target.value
                    this._editObjectField(id, field, val)
                }} />
            )
        } else {
            return (
                <Link
                    to={{
                        pathname: `/admin/objects/object`,
                        hash: `#${props.original.id}`,
                    }}
                >{props.value}</Link>
            )
        }

    }

    _renderNewsPage() {
        if (!this.state.sections || !this.state.sections.NewsSection || !this.state.sections.NewsSection.news) {
            return null
        }

        let data = []

        for (let key in this.state.sections.NewsSection.news) {
            data.push(this.state.sections.NewsSection.news[key])
        }

        const columns = [
            {
                Header: 'Заголовок',
                accessor: 'title',
                Cell: props => {
                    return (
                        <Link
                            to={{
                                pathname: `/admin/news/newsEditor`,
                                hash: `#${props.original.id}`,
                            }}
                        >{props.value}</Link>
                    )
                }
            },
            {
                Header: 'Дата',
                accessor: 'date',
                Cell: props => {
                    return (
                        <Link
                            to={{
                                pathname: `/admin/news/newsEditor`,
                                hash: `#${props.original.id}`,
                            }}
                        >{props.value}</Link>
                    )
                }
            },
            {
                Header: 'Отображается',
                accessor: 'isVisible',
                Cell: props => {
                    const id = props.original.id
                    const field = props.column.id
                    return (
                        <div className="TableSwitchWrapper">
                            <Switch
                                onColor={'#16864e'}
                                checked={props.value}
                                onChange={val => {
                                    const ref = `/sections/NewsSection/news/${id}`
                                    firebase.database().ref(ref).update({
                                        [field]: val
                                    });
                                }}
                            />
                        </div>
                    )
                }
            },
        ]

        return (
            <div className="ObjectsTable">
                <ReactTable
                    key={'NewsTable'}
                    showPagination={false}
                    defaultPageSize={data.length}
                    data={data}
                    columns={columns}
                />
            </div>
        )
    }

    _renderPageApplications() {
        if (!this.state.applications) {
            return null
        }

        let data = []

        for (let key in this.state.applications) {
            data.push(this.state.applications[key])
        }

        const columns = [
            {
                Header: 'Имя',
                accessor: 'name'
            },
            {
                Header: 'Телефон',
                accessor: 'phone'
            },
            {
                Header: 'E-mail',
                accessor: 'email'
            },
            {
                Header: 'Дата',
                accessor: 'date',
                Cell: props => {
                    return (
                        <div className="dateWrapper">
                            {moment(props.original.date, 'x').format('DD.MM.YYYY, h:mm:ss')}
                        </div>
                    )
                }
            },
            {
                Header: 'Закрыта',
                accessor: 'isNew',
                Cell: props => {

                    return (
                        <div className="TableSwitchWrapper">
                            <Switch
                                onColor={'#16864e'}
                                checked={!props.value}
                                onChange={val => {

                                    firebase.database().ref(`applications/${props.original.id}/`).update({
                                        'isNew': !val
                                    });
                                }}
                            />
                        </div>
                    )
                }
            }
        ]

        return (
            <div className="ObjectsTable">
                <ReactTable
                    key={'ApplicationsTagle'}
                    showPagination={false}
                    defaultPageSize={data.length}
                    data={data}
                    columns={columns}
                />
            </div>
        )

    }

    _renderPageObjects() {
        if (!this.state.objects) {
            return null
        }

        let data = []

        for (let key in this.state.objects) {
            data.push(this.state.objects[key])
        }

        const columns = [
            {
                Header: 'Название',
                accessor: 'title',
                Cell: this._renderObjectsTableCall.bind(this)
            },
            {
                Header: 'Адрес',
                accessor: 'address',
                Cell: this._renderObjectsTableCall.bind(this)
            },
            {
                Header: 'Застройщик',
                accessor: 'builder',
                Cell: this._renderObjectsTableCall.bind(this)
            },
            {
                Header: 'Дата сдачи',
                accessor: 'date',
                Cell: this._renderObjectsTableCall.bind(this)
            },
            {
                Header: 'Сдан',
                accessor: 'isReady',
                Cell: props => {
                    const id = props.original.id
                    const field = props.column.id

                    return (
                        <div className="TableSwitchWrapper">
                            <Switch
                                onColor={'#16864e'}
                                checked={props.value}
                                onChange={val => {
                                    this._editObjectField(id, field, val)
                                }}
                            />
                        </div>
                    )
                }
            },
            {
                Header: 'Отображается',
                accessor: 'isVisible',
                Cell: props => {
                    const id = props.original.id
                    const field = props.column.id
                    return (
                        <div className="TableSwitchWrapper">
                            <Switch
                                onColor={'#16864e'}
                                checked={props.value}
                                onChange={val => {
                                    this._editObjectField(id, field, val)
                                }}
                            />
                        </div>
                    )
                }
            },

        ]


        return (
            <div className="ObjectsTable">
                <ReactTable
                    key={'ObjectsTagle'}
                    showPagination={false}
                    defaultPageSize={data.length}
                    data={data}
                    columns={columns}
                />
            </div>
        )
    }

    render() {

        if (!this.props.user) {
            return (
                <ContainerLogin />
            )
        } else {
            return (
                <div className="ViewAdminWrapper">
                    <div style={{ zIndex: 99999, position: 'absolute' }} className="ToastWrapper">
                        <ToastContainer
                            position="top-right"
                            type="default"
                            autoClose={5000}
                            hideProgressBar={false}
                            newestOnTop={false}
                            closeOnClick
                            pauseOnHover
                        />
                    </div>
                    <div className="columns is-fullheight">
                        <aside className="ASide NoSidePadding column is-1 aside is-fullheight is-hidden-mobile">
                            <div className="UserWrapper">
                                <img src="http://i.pravatar.cc/300" alt="avatar" />
                            </div>
                            <div className="MainNavWrapper">
                                <Link to={`/admin/objects`} className={`MainNavWrapperItemWrapper ${this._checkActive('objects') ? 'ActiveLink' : ''}`}>
                                    <div className="MainNavWrapperItemIcon IconObjects" />
                                    <div className="MainNavWrapperItemText">
                                        {'Объекты'}
                                    </div>
                                </Link>
                                <Link to={`/admin/advantages`} className={`MainNavWrapperItemWrapper ${this._checkActive('advantages') ? 'ActiveLink' : ''}`}>
                                    <div className="MainNavWrapperItemIcon IconAdvantages" />
                                    <div className="MainNavWrapperItemText">
                                        {'Преимущества'}
                                    </div>
                                </Link>
                                <Link to={`/admin/competency`} className={`MainNavWrapperItemWrapper ${this._checkActive('competency') ? 'ActiveLink' : ''}`}>
                                    <div className="MainNavWrapperItemIcon IconCompetency" />
                                    <div className="MainNavWrapperItemText">
                                        {'Компетенции'}
                                    </div>
                                </Link>
                                <Link to={`/admin/news`} className={`MainNavWrapperItemWrapper ${this._checkActive('news') ? 'ActiveLink' : ''}`}>
                                    <div className="MainNavWrapperItemIcon IconNews" />
                                    <div className="MainNavWrapperItemText">
                                        {'Новости'}
                                    </div>
                                </Link>
                                <Link to={`/admin/settings`} className={`MainNavWrapperItemWrapper ${this._checkActive('settings') ? 'ActiveLink' : ''}`}>
                                    <div className="MainNavWrapperItemIcon IconSettings" />
                                    <div className="MainNavWrapperItemText">
                                        {'Настройки'}
                                    </div>
                                </Link>
                            </div>
                            <div className="ApplicationsWrapper">
                                <Link to={`/admin/applications`} className={`MainNavWrapperItemWrapper ${this._checkActive('applications') ? 'ActiveLink' : ''}`}>
                                    <div className="MainNavWrapperItemIcon IconApplications" />
                                    <div className="MainNavWrapperItemText">
                                        {'Заявки'}
                                    </div>
                                </Link>
                            </div>
                        </aside>
                        <div className="AdminContentWrapper column is-11">
                            {this._renderHeader()}
                            {this._renderPageTitle()}

                            <div className="GlobalContentWrapper column is-12">
                                {this.getContent()}
                            </div>
                        </div>
                    </div>
                </div>


            )
        }


    }
}

export default ViewAdmin


// WEBPACK FOOTER //
// ./src/Components/ViewAdmin.js